import { type EntityData, isEndorsementData } from '@ContractBuilder/types';
import { getDocumentContext } from '@ContractBuilder/utils';
import type { Branding } from '@domain/schemas/branding.schema';
import { useBrandingStore } from '@features/branding-edit/store/branding.store';

import { getResourceNameAndDocumentType } from '../utils/getResourceNameAndDocumentType';

export const useEntityAndDocumentType = (freshSubmission?: EntityData) => {
  const branding = useBrandingStore(({ branding }) => branding);

  let entity: EntityData | Partial<Branding> | null | undefined = undefined;
  let documentName = '';

  const documentContext = getDocumentContext();
  const { documentType, resourceName } = getResourceNameAndDocumentType(documentContext);

  switch (documentType) {
    case 'branding-document':
      entity = branding;
      documentName = 'PDF Preview';
      break;
    default:
      entity = freshSubmission;
      documentName = (entity && isEndorsementData(entity) ? entity.reference : entity?.name) ?? 'PDF Document';
      break;
  }

  return { entity, documentName, resourceName, documentType };
};
